import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  createLiveAccountSuccess,
  createLiveAccountFailure,
} from "../../Action/dashboard/createLiveAccountAction";
import { CREATE_LIVE_ACCOUNT } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* createLiveAccountRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post("/createLiveAccount", action?.payload?.payload),
      "Creating Live Account in progress..."
    );

    if (data?.code === 200) {
     
      yield put(createLiveAccountSuccess(data?.data));
      if (action?.payload?.callback) {
 
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(createLiveAccountFailure());
    }
  } catch (error) {
    yield put(createLiveAccountFailure());
  }
}

export function* watchCreateLiveAccountAPI() {
  yield takeEvery(CREATE_LIVE_ACCOUNT, createLiveAccountRequest);
}

export default function* rootSaga() {
  yield all([watchCreateLiveAccountAPI()]);
}
